module.exports = __webpack_public_path__ + "static/img/endrega.c9cfdba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/endrega.png
// module id = NGfs
// module chunks = 0